import { FC } from 'react';
import NotificationBellIcon from '@/assets/notification-bell.svg';

export const NotificationBell: FC = () => (
  <div className="h-6 w-6 text-gray-400">
    <NotificationBellIcon />
  </div>
);
